import React from 'react';



// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
    { path: '/', name: 'Home' },
    { path: '/dashboard', name: 'Dashboard' },
    { path: '/site', name: 'Site' },
    { path: '/site/overview', name: 'Overview' },
    { path: '/site/alarms', name: 'Alarms', exact: false },
    { path: '/site/alarms/:path', name: 'Alarms2', exact: true },
    { path: '/site/alarms/device_682X51089700005', name: 'Martin Marietta', exact: true },
    { path: '/verify', name: 'Verify Phone', exact: false },
    { path: '/account', name: 'My Account', exact: false },
    { path: '/invitations/account', name: 'Account Invitations', exact: true },
    { path: '/invitations/site', name: 'Site Invitations', exact: true },
    { path: '/help', name: 'Help', exact: true },

];



export default routes;



// WEBPACK FOOTER //
// ./src/routes.js